export default values => {
    const errors = {};
    const requiredFields = ["students"];
    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = "Required";
        }
    });

    return errors;
};
